<template>
	<v-container>
		<v-row>
			<v-col cols="12" sm="8" md="6" class="text-left">
				<template v-if="person && person.publications.length">
					<div class="" v-for="(pub, index) in publications" :key="index">
						<v-card class=" ma-2 pa-2" tile>
							<v-img class="" height="100px">
								<pdf :src="pub.url" style="height: 100px; "></pdf>
							</v-img>
							<v-card-title class="text-uppercase">{{ pub.name }}</v-card-title>

							<v-btn
								:color="pub.seen ? 'success' : 'accent'"
								small
								class="ma-2"
								:href="
									`#/guest/render-pdf?publicationId=${pub._id}&seen=${pub.seen}&urlPdf=${pub.url}`
								"
								target="_blank"
							>
								<v-icon small>
									mdi-eye-settings
								</v-icon>
								<span> {{ pub.seen ? 'Volver a ver' : 'Revisar' }}</span>
							</v-btn>
							<span v-if="pub.seen" class="caption">
								<v-icon small>
									mdi-check
								</v-icon>
								Visto el {{ formatSeen(pub) }}
							</span>
							<span v-else>Aún sin ver</span>
						</v-card>
					</div>
				</template>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import { frontend_url } from '@/config';
import pdf from 'vue-pdf';
import moment from 'moment';

export default {
	components: {
		pdf,
	},
	data() {
		return {
			position: 0,
		};
	},
	computed: {
		publications() {
			const publications = [...this.person.publications];
			return publications;
		},
		frontendUrl() {
			return frontend_url;
		},
		...mapGetters({
			person: 'Person/person',
		}),
	},
	methods: {
		goToPublication({ publicationId, seen, urlPdf }) {
			const routeData = this.$router.resolve({
				name: 'render-pdf',
				path: `render-pdf/${publicationId}/${seen}/${urlPdf}`,
			});
			window.open(routeData.href, '_blank');
		},
		formatPublicationDate(publication) {
			return moment(publication.updatedAt).format('DD-MM-YY HH:mm');
		},
		formatSeen(publication) {
			if (publication) return this.formatPublicationDate(publication);
			return 'Aún sin leer';
		},
	},
};
</script>
